import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { Heading } from 'components/Typography';

export type Props = {
  className?: string;
  icon?: React.ReactNode;
  heading?: string;
  headingDivider?: boolean;
  border?: boolean;
  children?: React.ReactNode;
};

export const Card = ({
  className,
  icon,
  heading,
  headingDivider = false,
  border = false,
  children,
}: Props): JSX.Element => {
  return (
    <div
      className={twMerge(
        cx('rounded-md bg-white', {
          'border border-black/16': border,
          'px-32 pb-32 md:px-40 md:pb-40': heading,
          'p-32 md:p-40': !heading,
        }),
        className,
      )}
    >
      {heading && (
        <div
          className={cx(
            'flex flex-col sm:flex-row gap-12 md:gap-12 sm:items-center -mx-32 md:-mx-40 p-32 pb-16 md:p-40 md:pb-16',
            {
              ' mb-32 md:mb-40 border-b border-black/16': headingDivider,
            },
          )}
        >
          {icon}

          <Heading level="h3" as="h3">
            {heading}
          </Heading>
        </div>
      )}

      {children}
    </div>
  );
};
